import { useSyncExternalStore } from 'react';
import {
  getDisplayTimeZone,
  subscribeDisplayTimeZone,
} from '@/lib/displayTimeZone';
import { useAbsoluteTimeFormat } from './useAbsoluteTimeFormat';

/**
 * The display time zone (Settings → Preferences → Time Zone). Re-renders the
 * caller when it changes, in this tab or another, so a component rendering
 * `formatDateTime` output follows the setting without a remount.
 *
 * Also re-renders on an absolute-format change (date order, 12/24-hour): the
 * formatters read that setting themselves, and every caller that passes this
 * zone to one renders their output.
 */
export function useDisplayTimeZone(): string {
  useAbsoluteTimeFormat();
  return useSyncExternalStore(subscribeDisplayTimeZone, getDisplayTimeZone);
}
